import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "product-details-accordion-size" }
const _hoisted_2 = { class: "product-details-accordion-size__text" }
const _hoisted_3 = ["src"]
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = { key: 0 }
const _hoisted_7 = ["href"]
const _hoisted_8 = ["innerHTML"]

import { computed, inject } from 'vue';

import useWebsiteTexts from '@/composables/useWebsiteTexts';
import useSizeDisplay from '@/composables/useSizeDisplay';


export default /*#__PURE__*/_defineComponent({
  __name: 'ProductDetailsAccordionSize',
  setup(__props) {

const { websiteText } = useWebsiteTexts();
const { getSizeName } = useSizeDisplay();

const { product, selectedSize } = inject('addToCartContext') as any;

const sizeGuideIcon = computed(() => {
  return product.value?.sizeGuideIconImageId
    ? `/api/media/image/${product.value.sizeGuideIconImageId}?maxWidth=42`
    : '';
});

const sizeHeader = computed(() => {
  return websiteText('sizeguide__measurement_size', {
    'variant.size': variant.value.size,
  }).value;
});

const sizeMeasurements = computed(() => {
  return selectedSize.value?.sizeMeasurements || [];
});

const completeSizeGuideLabel = computed(() => {
  return product.value?.completeSizeGuideLabel;
});

const completeSizeGuideUrl = computed(() => {
  return product.value?.completeSizeGuideUrl;
});

const hasCompleteSizeGuideLink = computed(() => {
  return completeSizeGuideLabel.value && completeSizeGuideUrl.value;
});

const variant = computed(() => {
  return {
    size: getSizeName(selectedSize.value?.sizeName),
    photomodelheight: product.value.photoModelInfo.height,
    photomodelsize: getSizeName(product.value.photoModelInfo.size),
  };
});

const photoModelInfo = computed(() => {
  if (!variant.value.photomodelheight || !variant.value.photomodelsize) {
    return '';
  }
  return `<span>${websiteText('sizeguide__photomodel_label').value}</span> ${
    websiteText('sizeguide__photomodel_value', {
      'variant.photoModelHeight': variant.value.photomodelheight,
      'variant.photoModelSize': variant.value.photomodelsize,
    }).value
  }`;
});

function measurementContent(measurement) {
  const formattedMeasurement = (+measurement.value)
    .toString()
    .replace(/\./g, ',');

  const measurementValue =
    websiteText(
      `sizeguide__measurement_${measurement.type.toLowerCase()}_value`,
      { value: formattedMeasurement }
    ).value || formattedMeasurement;

  return `<span>${measurement.label}:</span> ${measurementValue}`;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_unref(sizeGuideIcon))
        ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            src: _unref(sizeGuideIcon),
            alt: "Size guide icon"
          }, null, 8, _hoisted_3))
        : _createCommentVNode("", true),
      _createElementVNode("span", { innerHTML: _unref(sizeHeader) }, null, 8, _hoisted_4)
    ]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(sizeMeasurements), (measurement) => {
      return (_openBlock(), _createElementBlock("div", {
        key: measurement.type,
        class: "product-details-accordion-size__text",
        innerHTML: measurementContent(measurement)
      }, null, 8, _hoisted_5))
    }), 128)),
    (_unref(hasCompleteSizeGuideLink))
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createElementVNode("a", { href: _unref(completeSizeGuideUrl) }, _toDisplayString(_unref(completeSizeGuideLabel)), 9, _hoisted_7)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      innerHTML: _unref(photoModelInfo),
      class: "product-details-accordion-size__text"
    }, null, 8, _hoisted_8)
  ]))
}
}

})